import { map } from 'rxjs/operators';

const createPlayerInteractionsStream = interactions$ =>
    interactions$
        .pipe(
            map(({ type, data = {} }) => ({
                name: type,
                event: data,
            }))
        );


export default createPlayerInteractionsStream;
